import React from "react";

const TermsOfService = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.header}>Terms of Service</h1>
      <div style={styles.content}>
        <p>Welcome to our Terms of Service!</p>
        <p>
          These terms and conditions outline the rules and regulations for the
          use of OOTD.ai ("App") by Starforge PTE. LTD. ("Company"). By
          accessing and using this App, you accept these terms and conditions in
          full. If you do not agree with any part of these terms and conditions,
          please do not use our App.
        </p>
        <h2 style={styles.subheader}>License</h2>
        <p>
          Unless otherwise stated, Starforge PTE. LTD. owns the intellectual
          property rights for all material on the App. All intellectual property
          rights are reserved. You may view and/or print pages from the App for
          your own personal use subject to restrictions set in these terms and
          conditions.
        </p>
        <h2 style={styles.subheader}>User Content</h2>
        <p>
          By uploading photos and other content to our App, you grant Starforge
          PTE. LTD. a non-exclusive, royalty-free, worldwide, and transferable
          license to use, reproduce, distribute, prepare derivative works of,
          display, and perform such content in connection with the service and
          our business, including without limitation for promoting and
          redistributing part or all of the App in any media formats and through
          any media channels.
        </p>
        <h2 style={styles.subheader}>User Comments</h2>
        <p>
          This Agreement shall begin on the date hereof. Certain parts of this
          App offer the opportunity for users to post and exchange opinions,
          information, material, and data ("Comments"). We do not screen, edit,
          publish, or review Comments prior to their appearance on the App, and
          Comments do not reflect our views or opinions.
        </p>
        <h2 style={styles.subheader}>Prohibited Activities</h2>
        <p>
          Users are prohibited from using the App to engage in any activity that
          is illegal, harmful, or otherwise objectionable. This includes, but is
          not limited to, uploading content that is offensive, discriminatory,
          or infringes on intellectual property rights.
        </p>
        <h2 style={styles.subheader}>Data Collection and Privacy</h2>
        <p>
          We collect and use personal data in accordance with our Privacy
          Policy. By using our App, you consent to such processing and you
          warrant that all data provided by you is accurate.
        </p>
        <h2 style={styles.subheader}>Hyperlinking to our Content</h2>
        <p>
          The following organizations may link to our website without prior
          written approval: Government agencies, Search engines, News
          organizations, Online directory distributors, and Systemwide
          Accredited Businesses except soliciting non-profit organizations,
          charity shopping malls, and charity fundraising groups which may not
          hyperlink to our website.
        </p>
        <p>
          These organizations may link to our home page, to publications, or to
          other App information so long as the link: (a) is not in any way
          misleading; (b) does not falsely imply sponsorship, endorsement, or
          approval of the linking party and its products or services; and (c)
          fits within the context of the linking party's site.
        </p>
        <h2 style={styles.subheader}>OOTD PREMIUM MEMBERSHIP</h2>
        <p>
          We offer OOTD Premium Membership with subscription plans available on
          a weekly and monthly basis. By subscribing to OOTD Premium Membership,
          you agree to pay the subscription fees corresponding to the chosen
          plan. Subscription fees are billed in advance on a recurring basis and
          are non-refundable. You can manage your subscription and cancel at any
          time through your account settings.
        </p>
        <h2 style={styles.subheader}>Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by applicable law, Starforge PTE. LTD.
          shall not be liable for any direct, indirect, incidental, special,
          consequential, or punitive damages, or any other damages of any kind,
          arising out of or related to your use of the App.
        </p>
        <h2 style={styles.subheader}>Governing Law</h2>
        <p>
          These terms and conditions are governed by and construed in accordance
          with the laws of the United States and Canada, and you irrevocably
          submit to the exclusive jurisdiction of the courts in those states or
          countries.
        </p>
        <p>[Include additional sections of your Terms of Service as needed.]</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: "20px",
    maxWidth: "800px",
    margin: "0 auto",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.6",
  },
  header: {
    textAlign: "center",
    marginBottom: "20px",
  },
  subheader: {
    marginTop: "20px",
  },
  content: {
    textAlign: "justify",
  },
};

export default TermsOfService;
